<template>
  <div v-if="data">
    <div class="container container-fluid" :class="getCurrentModule">
      <h1 class="pull-left text-muted">Skapa ny indexpatient {{ moduleName }}</h1>
      <div class="clearfix"></div>
      <!-- Skapa ny -->
      <div class="card journal-card">
        <div class="card-body">
          <p class="text-dark pull-left"><strong>Ny indexpatient</strong></p>
          <div class="row">
            <div class="col-sm-4">
              <div class="form-group">
                <label class="pull-left" for="ssn">Personnummer:</label>
                <input type="number" placeholder="YYYYMMDDXXXX"
                  class="form-control" id="ssn" v-model="ssn" minlength="12" >
              </div>
              <button
                class="btn btn-primary btn-sm"
                @click="getFromNavet()"
                :disabled="!validSsn">Hämta från NAVET
              </button>
              <br />
              <small class="text-muted">
                Fyll i personnummer i formatet <i>YYYYMMDDXXXX</i> <br />
                för hämtning från NAVET
              </small>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label class="pull-left" for="lastname">Efternamn:</label>
                <input type="text" class="form-control" id="lastname" v-model="lastname">
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label class="pull-left" for="firstname">Tilltalsnamn:</label>
                <input type="text" class="form-control" id="firstname" v-model="firstname">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
      <!-- Kontaktuppgifter -->
      <div class="card journal-card">
        <div class="card-body">
          <p class="text-dark pull-left"><strong>Kontaktuppgifter</strong></p>
          <div class="row">
            <div class="col-sm">
              <div class="form-group">
                <label class="pull-left" for="email">E-post:</label>
                <input
                  type="text"
                  class="form-control"
                  id="email"
                  v-model="email"
                  autocomplete="off"
                  :class="((email && email.length > 0) && !validEmail(email)) ? 'invalid' : ''">
              </div>
            </div>
            <div class="col-sm">
              <div class="form-group">
                <label class="pull-left" for="phonenumber">Telefonnummer:</label>
                <input
                  type="text"
                  class="form-control"
                  id="phonenumber"
                  v-model="phonenumber"
                  autocomplete="off"
                  :maxlength="phoneLength"
                  @input="enforceNumbers()">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
      <!-- Personuppgifter -->
      <div class="card journal-card" v-if="populationInfo">
        <div class="card-body">
          <p class="text-dark pull-left"><strong>Personuppgifter</strong></p>
          <div class="row">
            <div class="col-sm-2">
              <p class="card-title">Address</p>
              <p class="card-title">Postkod</p>
              <p class="card-title">Stad</p>
              <p class="card-title">C/O-adressering</p>
              <p class="card-title">Dödsdatum</p>
              <p class="card-title">Sekretessmarkering</p>
              <p class="card-title">Skyddad identitet</p>
            </div>
            <div class="col-sm-4">
              <p class="card-title">{{ toTitleCase(populationInfo.streetAddress) || '-' }}</p>
              <p class="card-title">{{ populationInfo.postalCode || '-' }}</p>
              <p class="card-title">{{ toTitleCase(populationInfo.city) || '-' }}</p>
              <p class="card-title">{{ populationInfo.careOf || 'Nej' }}</p>
              <p class="card-title">{{ populationInfo.deathDate || '-' }}</p>
              <p class="card-title"
                title="Hantera uppgifterna med försiktighet!"
                :class="populationInfo.hasNoteOfSecrecy === true ? 'text-danger': ''">
                  {{ boolToText(populationInfo.hasNoteOfSecrecy) }}
              </p>
              <p class="card-title"
                title="Hantera uppgifterna med försiktighet!"
                :class="populationInfo.hasProtectedIdentity === true ? 'text-danger': ''">
                  {{ boolToText(populationInfo.hasProtectedIdentity) }}
              </p>
            </div>
            <div class="col-sm-4"></div>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
      <!-- FH-diagnos -->
      <div class="card journal-card">
        <div class="card-body">
          <p class="text-dark pull-left"><strong>FH-diagnos</strong></p>
          <div class="row">
            <div class="col-sm-7">
              <div class="form-group">
                <label class="pull-left" for="mutationlong">Långt mutationsnamn + kort mutationsnamn:</label>
                <!-- <input type="text" class="form-control" id="mutationlong" v-model="mutationlong"> -->
                <select
                  class="form-control"
                  v-model="mutation"
                  @change="emptyMutations()"
                  :disabled="((mutationlong && mutationlong.length !== 0) ||
                    (mutationshort && mutationshort.length !== 0)) || idxPatientType === 1">
                  <option :value="'Ej applicerbart'" v-if="idxPatientType === 1">Ej applicerbart</option>
                  <option :value="0">Välj mutation</option>
                  <option
                    v-for="(mutationshort, mutationlong) in data.clinicMisc.mutationlist"
                    :value="mutationlong + ' | ' + mutationshort"
                    :key="mutationlong">
                    {{ mutationlong }} {{ mutationshort }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-sm-5">
              <div class="form-group">
                <label class="pull-left" for="long-mutation">Långt mutationsnamn:</label>
                <div class="input-group">
                  <input type="text" class="form-control" id="long-mutation" placeholder="Skriv långt mutationsnamn"
                    v-model="mutationlong" :disabled="mutation !== 0" @input="emptyMutationChoice()">
                  <span class="input-group-append" title="Rensa fält">
                    <button type="button" :disabled="mutation !== 0"
                      @click="mutationlong = ''" class="input-clear"></button>
                  </span>
                </div>
              </div>
              <div class="form-group">
                <label class="pull-left" for="short-mutation">Kort mutationsnamn:</label>
                <div class="input-group">
                  <input type="text" class="form-control" id="short-mutation" placeholder="Skriv kort mutationsnamn"
                    v-model="mutationshort" :disabled="mutation !== 0" @input="emptyMutationChoice()">
                  <span class="input-group-append" title="Rensa fält">
                    <button type="button" :disabled="mutation !== 0"
                      @click="mutationshort = ''" class="input-clear"></button>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-2">
              <div class="form-group">
                <label for="diagnosisdate">Diagnosdatum:</label><br />
                <date-pick v-model="diagnosisdate" id="diagnosisdate" :displayFormat="'YYYY-MM-DD'"
                  :inputAttributes="{name: diagnosisdate, id: diagnosisdate, class: ['form-control'],
                    readonly: true, placeholder: 'Välj diagnosdatum'}"></date-pick>
              </div>
            </div>
            <div class="col-sm-5">
              <div class="form-group form-group-select">
                <label for="diagnosisfacility">Diagnosställe:</label>
                <select class="form-control" v-model="diagnosisfacility" @change="emptyLocation()"
                :disabled="diagnosislocation !== null && diagnosislocation.length !== 0">
                  <option :value="0">Välj diagnosställe</option>
                  <option
                    v-for="(region, facility) in data.clinicMisc.mutationFacilityList"
                    :value="facility"
                    :key="facility">
                    {{ facility }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-sm-5">
              <div class="form-group">
                <label class="pull-left" for="diagnosislocation">Annat diagnosställe:</label>
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    id="diagnosislocation"
                    placeholder="Skriv diagnosställe"
                    v-model="diagnosislocation"
                    :disabled="diagnosisfacility !== 0"
                    @input="emptyFacility()">
                  <span class="input-group-append" title="Rensa fält">
                    <button type="button" :disabled="diagnosisfacility !== 0"
                      @click="diagnosislocation = ''" class="input-clear"></button>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="row row-margin" v-if="(idxPatientType === 1 || idxPatientType === 2)">
            <div class="col-sm-4">
              <p class="text-dark pull-left">Högsta kända obehandlade LDL kolesterolvärde</p>
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span class="input-group-text">LDL</span>
                </div>
                <input type="text" class="form-control" v-model="ldl.ldl" @input="handleLDL()">
              </div>
            </div>
            <div class="col-sm-2">
              <p class="text-dark pull-left"><strong>Enhet</strong></p>
              <div class="input-group mb-3">
                <input type="text" class="form-control" v-model="ldl.ldlUnit" disabled>
              </div>
            </div>
            <div class="col-sm-2">
              <p class="text-dark pull-left"><strong>Referensintervall</strong></p>
              <div class="input-group mb-3">
                  <select class="form-control" v-model="ldl.ldlReferenceInterval">
                    <option :value="''">Välj intervall för LDL</option>
                    <option
                      v-for="(ldl, i) in intervalLists.clinicMisc.ldlRefList"
                      v-html="ldl"
                      :key="i"
                      :title="toElementTitle(ldl)">
                    </option>
                  </select>
              </div>
            </div>
            <div class="col-sm-4">
              <p class="text-dark text-dlcn pull-left">
                <strong>Dutch Lipid Clinic Network Criteria Score som FH diagnos grundar sig på</strong>
              </p>
              <select class="form-control" v-model="dlcn">
                <option :value="''">Välj från 0-18</option>
                <option v-for="d in dlcnIntervals" :value="d" :key="d">{{ d }}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
      <!-- Omfattning screening -->
      <div class="card journal-card">
        <div class="card-body">
          <p class="text-dark pull-left"><strong>Omfattning screening</strong></p>
          <div class="row">
            <div class="col-sm-4">
              <div class="checkbox">
                <label><input type="radio" v-model="screening" value="1"> &nbsp; Mammas sida</label>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="checkbox">
                <label><input type="radio" v-model="screening" value="2"> &nbsp; Pappas sida</label>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="checkbox">
                <label><input type="radio" v-model="screening" value="3"> &nbsp; Okänt</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
      <div class="alert alert-danger alert-bottom-right alert-createnewidx">
        <strong>{{error}}</strong>
      </div>
      <div class="btn-group">
        <button class="btn btn-lg btn-primary" v-if="idxPatientType !== 1"
          @click="addNewIdxPat()" :disabled="!isFieldsValid">
          Skapa indexpatient
        </button>
        <button class="btn btn-lg btn-primary" v-if="idxPatientType === 1"
          @click="addNewIdxPat()" :disabled="!isGenNegFieldsValid">
          Skapa indexpatient
        </button>
        <button class="btn btn-lg btn-danger" @click="confirmLeave()">Avbryt</button>
      </div>
      <div class="clearfix"></div>
    </div>
  </div>
</template>

<script>
import config from '../../config/index.js'
import axios from '../plugins/axios'
import { request } from '../plugins/datocms'
import { luhnSsn } from '../plugins/luhnssn'
import { inRange } from '../plugins/numberhelper'
import DatePick from 'vue-date-pick'
import 'vue-date-pick/dist/vueDatePick.css'
import $ from 'jquery'

export default {
  name: 'createnewidx',
  props: ['patientType'],
  components: {
    DatePick
  },
  data () {
    return {
      data: null,
      ssn: null,
      populationInfo: null,
      error: 'Det gick inte att skapa ny indexpatient, vänligen försök igen om en stund.',
      lastname: '',
      firstname: '',
      email: '',
      phonenumber: null,
      mutation: 0,
      mutationlong: '',
      mutationshort: '',
      ldl: {
        ldl: '',
        ldlUnit: 'mmol/L',
        ldlReferenceInterval: ''
      },
      dlcn: '',
      diagnosisdate: null,
      diagnosisfacility: 0,
      diagnosislocation: '',
      screening: null,
      invitationmethod: '',
      invitationtext: '',
      phoneLength: 10,
      patient: null,
      moduleName: '',
      idxPatientType: localStorage.getItem('patientType'),
      clinicianId: localStorage.getItem('clinicianId') || 0
    }
  },
  methods: {
    toElementTitle (str) {
      if (str) {
        let res = $('<textarea />').html(str).text() // convert special html entity chars
        res = res.replace(/<[^>]*>?/gm, '') // strip html tags
        return res
      }
    },
    toTitleCase (phrase) {
      if (phrase) {
        return phrase
          .toLowerCase()
          .split(' ')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ')
      }
    },
    boolToText (bool) {
      if (bool) {
        return 'Ja ⚠️'
      } else {
        return 'Nej'
      }
    },
    handleLDL () {
      this.ldl.ldl = this.ldl.ldl.replace(/[^0-9.,]/g, '')
    },
    enforceNumbers () {
      this.phonenumber = this.phonenumber.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')
    },
    validEmail (email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(String(email).toLowerCase())
    },
    prePopulateLDLReferenceInterval (age, gender) {
      if (inRange(age, 0, 1)) {
        this.ldl.ldlReferenceInterval = this.intervalLists.clinicMisc.ldlRefList[0]
      } else if (inRange(age, 1, 14)) {
        this.ldl.ldlReferenceInterval = this.intervalLists.clinicMisc.ldlRefList[1]
      } else if (inRange(age, 14, 17) && gender === 'Kvinna') {
        this.ldl.ldlReferenceInterval = this.intervalLists.clinicMisc.ldlRefList[1]
      } else if (inRange(age, 14, 17) && gender === 'Man') {
        this.ldl.ldlReferenceInterval = this.intervalLists.clinicMisc.ldlRefList[1]
      } else if (inRange(age, 18, 30) && gender === 'Kvinna') {
        this.ldl.ldlReferenceInterval = this.intervalLists.clinicMisc.ldlRefList[2]
      } else if (inRange(age, 18, 30) && gender === 'Man') {
        this.ldl.ldlReferenceInterval = this.intervalLists.clinicMisc.ldlRefList[2]
      } else if (inRange(age, 31, 50) && gender === 'Kvinna') {
        this.ldl.ldlReferenceInterval = this.intervalLists.clinicMisc.ldlRefList[3]
      } else if (inRange(age, 31, 50) && gender === 'Man') {
        this.ldl.ldlReferenceInterval = this.intervalLists.clinicMisc.ldlRefList[3]
      } else if (inRange(age, 51, 120) && gender === 'Kvinna') {
        this.ldl.ldlReferenceInterval = this.intervalLists.clinicMisc.ldlRefList[4]
      } else if (inRange(age, 51, 120) && gender === 'Man') {
        this.ldl.ldlReferenceInterval = this.intervalLists.clinicMisc.ldlRefList[4]
      }
    },
    idxPatSsn (ssn) {
      if (ssn) {
        const output = ssn.substring(0, 4) + '-' +
                      ssn.substring(4, 6) + '-' +
                      ssn.substring(6, 8) + '-' +
                      ssn.substring(8, 12)
        return output
      }
      return '-'
    },
    getFromNavet () {
      let loader = this.$loading.show()
      axios.postPopulationRegistry(config.populationRegistryUri, this.ssn).then((response) => {
        if (response) {
          this.populationInfo = response.data
          this.firstname = response.data.firstName !== null ? response.data.firstName : ''
          this.lastname = response.data.lastName !== null ? response.data.lastName : ''
          loader.hide()
        }
      }, (error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          loader.hide()
          console.log(error)
        }
      })
    },
    emptyFacility () {
      this.diagnosisfacility = 0
    },
    emptyLocation () {
      this.diagnosislocation = ''
    },
    emptyMutations () {
      this.mutationlong = ''
      this.mutationshort = ''
    },
    emptyMutationChoice () {
      this.mutation = 0
    },
    showInvMethod (method) {
      if (method === 'sms') {
        return 'SMS'
      }
      if (method === 'email') {
        return 'E-post'
      }
    },
    confirmLeave () {
      const r = confirm('Är du säker? Du kan ha osparade ändringar.')
      if (r) {
        this.$router.go(-1)
      }
    },
    setCurrentModuleName () {
      switch (this.idxPatientType) {
        case 1:
          this.moduleName = '- Gen negativ'
          break
        case 2:
          this.moduleName = '- Gen positiv'
          break
        case 3:
          this.moduleName = '- Kardiolog'
          break
        default:
          this.moduleName = ''
          break
      }
    },
    handlePatientTypesAndConversions () {
      this.idxPatientType = this.patientType
        ? this.patientType : parseInt(localStorage.getItem('patientType'))
      if (isNaN(this.idxPatientType)) {
        this.$router.push('/landingpage')
      }
      this.setCurrentModuleName()
      if (sessionStorage.getItem('patientToBeConverted')) {
        const patient = JSON.parse(sessionStorage.getItem('patientToBeConverted'))
        if (patient.type === 'screening') {
          this.getPatientAndMutationById(patient.id)
        }
        if (patient.type === 'cardio') {
          this.idxPatientType = patient.idxPatType
          this.moduleName = this.idxPatientType === 1
            ? this.moduleName + ' (gen negativ)' : this.moduleName + ' (gen positiv)'
          this.getSetCardioPatientById(patient)
        }
      }
      this.mutation = this.idxPatientType === 1 ? 'Ej applicerbart' : 0
    },
    getPatientAndMutationById (id) {
      let loader = this.$loading.show()
      axios._get(config.familytreeUri + '/byId?PersonId=' + id).then(response => {
        this.patient = response.data.relativeData
        if (this.patient) {
          this.ssn = this.patient.ssn
          this.lastname = this.patient.lastName
          this.firstname = this.patient.firstName
          this.email = this.patient.emailAddress
          this.phonenumber = this.patient.phoneNumber
          if (this.phonenumber && !this.phonenumber.startsWith('0')) {
            this.phonenumber = '0' + this.phonenumber
          }
          axios._get(config.geneticTestUri + '?PersonId=' + id).then(response => {
            const result = response.data.geneticTestData
            this.mutationshort = result.mutation
            this.mutationlong = result.mutationLong
            this.diagnosislocation = result.diagnosisLocation
            this.diagnosisdate = result.diagnosisDate
          }).catch((error) => {
            if (error.response && error.response.status === 401) {
              window.location.href = window.location.origin.concat('/error')
            } else {
              console.log('Could not get genetictest: ' + error)
            }
          })
        }
        loader.hide()
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log('Could not get patient by id ' + this.$props.id + ', Error: ' + error)
          loader.hide()
        }
      })
    },
    getSetCardioPatientById (cardioPat) {
      let loader = this.$loading.show()
      axios._get(config.cardioUri + '/byId?PersonId=' + cardioPat.id).then(response => {
        this.cardioPatient = response.data.cardioPatientData
        if (this.cardioPatient) {
          this.ssn = this.cardioPatient.ssn
          this.lastname = this.cardioPatient.lastName
          this.firstname = this.cardioPatient.firstName
          this.email = this.cardioPatient.email
          this.phonenumber = this.cardioPatient.phoneNumber
          this.mutationshort = this.cardioPatient.mutation.mutation
          this.mutationlong = this.cardioPatient.mutation.mutationLong
          this.diagnosislocation = this.cardioPatient.mutation.diagnosisLocation
          this.diagnosisdate = this.cardioPatient.mutation.diagnosisDate
          this.ldl.ldl = cardioPat.data.ldl
          this.dlcn = cardioPat.data.dlcn
        }
        loader.hide()
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log('Could not get cardiopatient by id ' + this.$props.id + ', Error: ' + error)
          loader.hide()
        }
      })
    },
    addNewIdxPat () {
      const r = confirm('Är du säker på att du vill skapa en ny indexpatient?')
      if (r) {
        const idxPat = {
          firstname: this.firstname,
          lastname: this.lastname,
          ssn: this.ssn.toString(),
          mutation: this.mutation !== 0
            ? this.mutation.split(' | ')[1] : this.mutationshort,
          mutationlong: this.mutation !== 0
            ? this.mutation.split(' | ')[0] : this.mutationlong,
          diagnosisdate: this.diagnosisdate,
          diagnosislocation: this.diagnosisfacility !== 0
            ? this.diagnosisfacility : this.diagnosislocation,
          screening: parseInt(this.screening),
          email: this.email,
          phonenumber: this.phonenumber,
          clinicianid: parseInt(this.clinicianId),
          idxPatientType: parseInt(this.idxPatientType),
          highestLDL: (this.ldl && this.ldl.ldl.length > 0) ? JSON.stringify(this.ldl) : null,
          highestDLCN: (this.dlcn && this.dlcn.toString().length > 0) ? this.dlcn : null
        }
        // Add gene negative/positive specific properties for index patient
        if (this.idxPatientType === 1) {
          idxPat.mutation = 'Ej applicerbart'
          idxPat.mutationlong = 'Ej applicerbart'
        }

        let loader = this.$loading.show()
        if (idxPat) {
          axios.postIndexPatient(config.indexPatientUri, idxPat).then((response) => {
            if (response) {
              sessionStorage.removeItem('patientToBeConverted')
              setTimeout(() => {
                loader.hide()
                switch (this.idxPatientType) {
                  case 1: // gene negative
                    window.location.href = window.location.origin.concat('/patients_gen_negative')
                    break
                  case 2: // gene positive
                    window.location.href = window.location.origin.concat('/indexpatients')
                    break
                  case 3: // cardio
                    window.location.href = window.location.origin.concat('/patientscardio')
                    break
                  default: // fallback route
                    window.location.href = window.location.origin.concat('/indexpatients')
                    break
                }
              }, 1000)
            }
          }, (error) => {
            if (error.response && error.response.status === 401) {
              window.location.href = window.location.origin.concat('/error')
            } else {
              loader.hide()
              try {
                this.error = error.response.data
                  ? error.response.data[0]
                  : this.error
                $('.alert-createnewidx').show().delay(4000).fadeOut()
              } catch (err) {
                console.log(err)
              }
            }
          })
        }
      }
    }
  },
  watch: {
    getAge (age) {
      if (age) {
        this.prePopulateLDLReferenceInterval(age, this.getGender)
      } else {
        this.ldl.ldlReferenceInterval = ''
      }
    },
    diagnosisdate (dd) {
      if (!dd || dd.length === 0) {
        this.diagnosisdate = null
      }
    }
  },
  computed: {
    isFieldsValid () {
      if (this.validSsn && (this.firstname && this.firstname.length !== 0) && (this.lastname && this.lastname.length !== 0) &&
        ((this.email && this.email.length !== 0) || this.phonenumber !== null) &&
        (this.mutation !== 0 || ((this.mutationlong && this.mutationlong.length !== 0) &&
        (this.mutationshort && this.mutationshort.length !== 0))) &&
        (this.diagnosisfacility !== 0 || (this.diagnosislocation && this.diagnosislocation.length !== 0)) &&
        this.screening !== null && this.diagnosisdate !== null) {
        return true
      }
    },
    isGenNegFieldsValid () {
      if (this.validSsn && (this.firstname && this.firstname.length !== 0) && (this.lastname && this.lastname.length !== 0) &&
        ((this.email && this.email.length !== 0) || this.phonenumber !== null) && this.screening !== null) {
        return true
      }
    },
    getAge () {
      if (this.validSsn) {
        const today = new Date()
        const birthDate = new Date(this.ssn.substring(0, 4) +
          '/' + this.ssn.substring(4, 6) + '/' + this.ssn.substring(6, 8))
        let age = today.getFullYear() - birthDate.getFullYear()
        const m = today.getMonth() - birthDate.getMonth()
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
          age--
        }
        return age
      }
    },
    getGender () {
      if (this.validSsn) {
        const n = parseInt(this.ssn.charAt(10))
        if (n % 2 === 0) { // Even Number
          return 'Kvinna'
        }
        return 'Man'
      }
    },
    dlcnIntervals () {
      return Array.from(Array(19).keys())
    },
    validSsn () {
      const ssnValid = luhnSsn(this.ssn)
      return ssnValid
    },
    getCurrentModule () {
      switch (this.idxPatientType) {
        case 1:
          return 'bg--gen-negative'
        case 2:
          return 'bg--gen-positive'
        case 3:
          return 'bg--cardio'
        default:
          return ''
      }
    }
  },
  async mounted () {
    this.data = await request({
      query: `
        {
          clinicMisc {
            mutationlist
            mutationFacilityList
          }
        }
      `
    })
    this.intervalLists = await request({
      query: `
        {
          clinicMisc {
            ldlRefList
          }
        }
      `
    })
    this.handlePatientTypesAndConversions()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
button:disabled {
  opacity: 0.3;
}
select:disabled {
  opacity: 0.5;
}
input[type=text]:disabled {
  opacity: 0.5;
}
input[type=checkbox] {
    transform: scale(1.5);
}
.row-margin {
  margin-top: 3vh;
}
.text-dlcn {
  font-size: 80%;
  margin-bottom: 2.25vh;
}
.invalid {
  border: 2px solid red;
}
.pull-left {
  text-align: left;
}
.pull-right {
  text-align: right;
}
.form-group-select {
  position: absolute;
  bottom: 0;
}
.journal-card:hover {
  background: #f8e9b8;
  border: 1px solid #efe4c2;
  color: #000;
  opacity: 1.0;
}
.journal-card {
  background: #fff8e2;
  border: 1px solid #0000002f;
  color: #38362E;
  opacity: 0.8;
}
.alert-createnewidx {
  word-wrap: break-word;
}
</style>



// WEBPACK FOOTER //
// src/components/CreateNewIdx.vue